import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent, Register } from '@xanadu/core';
import { Club } from '@xanadu/model';
import { ClubCache } from '@xanadu/cache';

@Component({
    selector: 'app-club-panel',
    templateUrl: './club-panel.component.html',
    styleUrls: ['./club-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('club-panel')
export class ClubPanelComponent extends PanelComponent<Club> {
    private readonly clubCache = inject(ClubCache);

    private tabClub = { caption: 'Club', active: true, hidden: false };

    protected override get nodeType(): string | undefined {
        return 'client';
    }

    protected override setup(club: Club): void {
        super.setup(club);

        this.tabs = [
            this.tabClub
        ];
        this.tabSelected = this.tabClub;
    }

    protected override refresh(club: Club): void {
        super.refresh(club);

        this.clubCache.update();
    }
}
